/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TableModalState {
  open: boolean;
  title: string;
  content: JSX.Element | null;
}

const initialState: TableModalState = {
  open: false,
  title: '',
  content: null,
};

const tableModalSlice = createSlice({
  name: 'tableModal',
  initialState,
  reducers: {
    /**
     * Table Modal
     * @param {any} state - The current state.
     * @param {any} action - The action object.
     */
    openTableModal(state, action: PayloadAction<{ title: string; content: JSX.Element }>) {
      state.open = true;
      state.title = action.payload.title;
      state.content = action.payload.content;
    },
    /**
     * Close Table Modal
     * @param {any} state - The current state.
     */
    closeTableModal(state) {
      state.open = false;
      state.title = '';
      state.content = null;
    },
  },
});

export const { openTableModal, closeTableModal } = tableModalSlice.actions;
export default tableModalSlice.reducer;
